import React, { Component } from "react";
import { Upload, message, Modal, Button } from "antd";
import { InboxOutlined } from "@ant-design/icons";
import BasicFolderTree from "../foldertree/basic";
// import * as qiniu from "qiniu-js";

const { Dragger } = Upload;

class imguploader extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.handleFileProgressChange = this.handleFileProgressChange.bind(this);
    // this.customRequest = this.customRequest.bind(this);
    // this.onUploadError = this.onUploadError.bind(this);
    // this.beforeUpload = this.beforeUpload.bind(this);
  }

  state = {
    selectedNode: "请先选择文件夹" as any,
  };

  // customRequest(e) {
  //   console.log(e);
  //   const { token } = this.props;
  //   const { file } = e;
  //   const { name } = file;
  //   const config = {
  //     useCdnDomain: true,
  //     region: qiniu.region.z2,
  //   };
  //   const putExtra = {
  //     // fname: "qiniu.txt",
  //     // mimeType: "text/plain",
  //     // customVars: { 'x:test': 'qiniu'},
  //     // metadata: { 'x-qn-meta': 'qiniu'},
  //   };
  //   const observable = qiniu.upload(file, name, token, putExtra, config);

  //   const observer = {
  //     next: this.onQiniuUploadProgressChange,
  //     error: this.onUploadError,
  //     complete: this.onUploadComplete,
  //   };
  //   // or
  //   const subscription = observable.subscribe(observer);
  //   // subscription.unsubscribe() // 上传取消
  // }

  // onQiniuUploadProgressChange(e) {
  //   console.log(e);
  // }

  handleFileProgressChange(info) {
    const { onAddResource } = this.props;
    console.log("progress", info);
    const { status, name, response, type } = info.file;
    if (status !== "uploading") {
      console.log(info.file, info.fileList);
    }
    if (status === "done") {
      // const path = name.split(".")[0];
      // const suffix = name.split(".")[1];
      const {
        selectedNode: { id },
      } = this.state;
      const resourceType = type.split()[0];
      console.log(resourceType);
      const resource = {
        folderId: id,
        resourceName: name,
        resourceType: resourceType,
        // resourcePath: `${response.key}.${suffix}`, // 七牛存储后的地址不需要后缀
        resourcePath: `${response.key}`,
        bucket: "lm-product-resources-public",
        domain: "resources.cattrip.net",
      };
      onAddResource(resource).then((res) => {
        console.log("rs", res);
        message.success(`${info.file.name} file uploaded successfully.`);
      });
    } else if (status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  }

  // ! deprecated
  getResourceType(resourceSuffix): string {
    const collectImgType = ["jpg", "webp", "png", "jpeg", "gif"];
    const collectVideoType = ["avi", "mp4", "rmvb", "rm", "mpeg", "flv", "mov"];
    if (collectImgType.includes(resourceSuffix)) {
      return "img";
    }
    if (collectVideoType.includes(resourceSuffix)) {
      return "video";
    }
  }

  // onUploadError = (err) => {
  //   console.log();
  // };

  // onUploadComplete(res) {
  //   console.log(res);
  // }

  beforeUpload(file, fileList) {
    const { name } = file;
    return new Promise((resolve, reject) => {
      this.props.onCheckResourceUnique(name).then((res) => {
        if (res.data === false) {
          reject();
          message.error(`文件名${name}重复`);
        }
        resolve();
      });
    });
  }

  onUploadListRemove(e) {
    console.log(e);
    const { onRemoveResource } = this.props;
    // todo
    // return new Promise((resove, reject) => {
    //   onRemoveResource().then((res) => {
    //     console.log(res);
    //   });
    // });
  }

  render() {
    const { token, treeData, visible, onCancel, onOK } = this.props;
    const { selectedNode } = this.state;
    return (
      <Modal
        visible={visible}
        maskClosable
        centered
        closable={false}
        onCancel={onCancel}
        // onOk={onOK}
        footer={null}
      >
        <BasicFolderTree
          treeData={treeData}
          onTreeSelect={(nodeName, nodeInfo) => {
            this.setState({ selectedNode: nodeInfo });
          }}
          value={selectedNode}
        />
        <Dragger
          multiple={true}
          action="http://up-z2.qiniup.com"
          data={{ token }}
          disabled={selectedNode === "请选择"}
          showUploadList={{
            showRemoveIcon: false,
            showPreviewIcon: false,
            showDownloadIcon: false,
          }}
          // headers={{ host: "" }}
          // accept=".jpg,.jpeg,.png,.webp,.gif"
          onChange={this.handleFileProgressChange}
          beforeUpload={this.beforeUpload.bind(this)}
          onPreview={(e) => {
            const {
              response: { hash },
            } = e;
            window.open(`http://resources.cattrip.net/${hash}`);
          }}
          // onRemove={this.onUploadListRemove.bind(this)}
          listType="picture"
          // customRequest={this.customRequest}
          // progress={null}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">
            Click or drag file to this area to upload
          </p>
          <p className="ant-upload-hint">
            Support for a single or bulk upload. Strictly prohibit from
            uploading company data or other band files
          </p>
        </Dragger>
      </Modal>
    );
  }
}

export default imguploader;
